function weixinFg (val) {
  var appid = localStorage.getItem('appId') // appid
  var url = window.encodeURIComponent(`${val}homeIndex`) // 回调链接地址，需转码为URI格式，必须去除#后的参数
  var scope = 'snsapi_userinfo' // snsapi_base静默授权，snsapi_userinfo弹出授权页面
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`
}
// function prohibitweixinShare() {
//     // console.log('1111')
//     // 微信环境下禁用分享
//     document.addEventListener(
//         'WeixinJSBridgeReady',
//         function onBridgeReady() {
//             console.log('9999999999999999')
//             console.log(WeixinJSBridge)
//             // 通过下面这个API隐藏右上角按钮
//             WeixinJSBridge.call('hideOptionMenu')
//         }
//     )
// }
function onBridgeReady () {
  WeixinJSBridge.call('hideOptionMenu')
}
function prohibitweixinShare () {
  return
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}
function showOptionMenuFg () {
  if (this.isWexinLogin) {
    // 微信环境下禁用分享
    document.addEventListener('WeixinJSBridgeReady', function onBridgeReady () {
      // 通过下面这个API显示右上角按钮
      WeixinJSBridge.call('showOptionMenu')
    })
  }
}
function shareExtensionFg (obj) {
  //分享关系
  this.http('Client.shareExtension', {
    share_member_id: obj.uid,
    share_staff_id: 0,
    scenes: obj.scenes,
    extend_id: obj.goods_id
  }).then(res => {
    console.log(res)
  })
}
function analysisUrl (url) {
  let hrr = []
  let obj = {}
  //截取内部参数
  let params = url.substr(url.indexOf('?') + 1)
  //逗号隔开
  let str = params.replace(/\&/g, ',')
  console.log(str)
  let crr = []
  str.split(',').map((i, index) => {
    crr.push(i.replace(/\=/g, ',').split())
  })
  crr.map(item => {
    item.forEach(i => {
      hrr.push(i.split(','))
    })
  })
  hrr.map(item => {
    obj[item[0]] = item[1]
  })
  console.log(obj)
  return obj
}

//阿拉伯数字转换成大写汉字
function numberParseChina (num) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    alert('Number is wrong!')
    return 'Number is wrong!'
  }
  var AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九')
  var BB = new Array('', '十', '百', '千', '万', '亿', '点', '')
  var a = ('' + num).replace(/(^0*)/g, '').split('.'),
    k = 0,
    re = ''
  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp('0{4}\\d{' + (a[0].length - i - 1) + '}$').test(a[0]))
          re = BB[4] + re
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
      re = AA[0] + re
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
    k++
  }
  if (a.length > 1) {
    //加上小数部分(如果有小数部分)
    re += BB[6]
    for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
  }
  return re
}
function add0 (m) {
  return m < 10 ? '0' + m : m
}
function format (shijianchuo, isType) {
  var time = new Date(shijianchuo)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var s = time.getSeconds()
  if (isType) {
    console.log(shijianchuo)
    return add0(m) + '月' + add0(d) + '号 ' + add0(h) + ':' + add0(mm)
  }
  return (
    y +
    '-' +
    add0(m) +
    '-' +
    add0(d) +
    ' ' +
    add0(h) +
    ':' +
    add0(mm) +
    ':' +
    add0(s)
  )
}

// 判断iphonex
function isIphoneX () {
  let result = false
  let u = navigator.userAgent
  let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isIos) {
    if (screen.height === 812 && screen.width === 375) {
      result = true
    }
  }
  return result
}

export {
  weixinFg,
  prohibitweixinShare,
  shareExtensionFg,
  showOptionMenuFg,
  analysisUrl,
  numberParseChina,
  format,
  isIphoneX
}
